import { cn } from "@/utils/cn";
import { memo } from "react";

interface SearchIconProps {
  className?: string;
}

export const SearchIcon = memo(function SearchIcon({ className }: SearchIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-black", className)}
    >
      <path d="M21.4636 20.4058L16.7841 15.7273C18.1404 14.0989 18.8167 12.0104 18.6724 9.89611C18.528 7.78183 17.5741 5.80459 16.0091 4.37571C14.444 2.94684 12.3884 2.17633 10.2697 2.22448C8.15108 2.27263 6.13255 3.13573 4.63405 4.63423C3.13554 6.13273 2.27245 8.15126 2.2243 10.2699C2.17615 12.3886 2.94665 14.4442 4.37553 16.0093C5.80441 17.5743 7.78164 18.5282 9.89592 18.6725C12.0102 18.8169 14.0987 18.1406 15.7271 16.7843L20.4056 21.4638C20.4751 21.5332 20.5576 21.5883 20.6483 21.6259C20.7391 21.6635 20.8364 21.6829 20.9346 21.6829C21.0328 21.6829 21.1301 21.6635 21.2209 21.6259C21.3116 21.5883 21.3941 21.5332 21.4636 21.4638C21.533 21.3943 21.5881 21.3118 21.6257 21.2211C21.6633 21.1303 21.6827 21.033 21.6827 20.9348C21.6827 20.8365 21.6633 20.7393 21.6257 20.6485C21.5881 20.5577 21.533 20.4753 21.4636 20.4058ZM3.73817 10.4674C3.73817 9.13651 4.13282 7.83552 4.87221 6.72893C5.61161 5.62235 6.66254 4.75987 7.89211 4.25057C9.12168 3.74126 10.4747 3.60801 11.78 3.86765C13.0853 4.12729 14.2843 4.76817 15.2254 5.70924C16.1664 6.65031 16.8073 7.84931 17.0669 9.15462C17.3266 10.4599 17.1933 11.8129 16.684 13.0425C16.1747 14.272 15.3122 15.323 14.2057 16.0624C13.0991 16.8018 11.7981 17.1964 10.4672 17.1964C8.68316 17.1944 6.97275 16.4849 5.71124 15.2234C4.44973 13.9618 3.74015 12.2514 3.73817 10.4674Z" />
    </svg>
  );
});
